import { render, staticRenderFns } from "./CustomerParameterDetail.vue?vue&type=template&id=1a835bc2"
import script from "./CustomerParameterDetail.vue?vue&type=script&lang=js"
export * from "./CustomerParameterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports